<template>
  <div class="user list-group-item items-center py-2">
    <div class="list-group-item-figure items-start">
      <a :class="{ 'user-avatar-lg': avatarSize === 'lg' }"
         :href="'/user/' + user.id"
         @click.prevent="showUser"
         class="user-avatar"
         v-if="user.avatar">
        <img :src="user.avatar" alt="">
      </a>
      
      <a :class="{ 'tile-lg': avatarSize === 'lg' }"
         :href="'/user/' + user.id"
         @click.prevent="showUser"
         class="tile tile-circle bg-blue-500"
         v-if="user.name && !user.avatar">
        {{ initials }}
      </a>
    </div>
    
    <div class="list-group-item-body">
      <h4 class="list-group-item-title">
        <a href="#" @click.prevent="showUser">{{ user.full_name }}</a>
      </h4>
      <div class="list-group-item-subtitle">
        <span class="text-muted small">{{ user.email }}</span>
      </div>
    </div>
    
    <div class="list-group-item-figure" v-if="showAddRemoveButton">
      <button @click="confirming = true"
              type="button"
              class="btn btn-sm btn-primary"
              style="min-width: 63.7px"
              :disabled="isSelected"
              v-if="!confirming">Agregar
      </button>
      
      <div v-else class="d-flex justify-content-between">
        <button class="btn btn-sm btn-primary mr-2"
                type="button"
                :disabled="selectingUser"
                @click="selectUser">
          <template v-if="!selectingUser">Confirmar</template>
          
          <span class="spinner-border text-yellow-500 spinner-border-sm" role="status" v-if="selectingUser">
            <span class="sr-only">Guardando...</span>
          </span>
        </button>
        <button class="btn btn-sm btn-secondary"
                type="button"
                @click="confirming = false"
                :disabled="selectingUser">Cancelar
        </button>
      </div>
    </div>
    
    <div class="list-group-item-figure" v-if="showOptions">
      <div class="dropdown">
        <button class="btn btn-sm btn-icon btn-light" data-toggle="dropdown">
          <i class="fa fa-fw fa-ellipsis-v"></i>
        </button>
        <div class="dropdown-arrow"></div>
        <div class="dropdown-menu dropdown-menu-right">
          <button class="dropdown-item" type="button">Edit</button>
          <button class="dropdown-item" type="button">Remove</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UserListItem',
    props: {
      user: Object,
      
      showOptions: {
        type: Boolean,
        default: false,
      },
      showAddRemoveButton: {
        type: Boolean,
        default: true,
      },
      avatarSize: {
        default: 'md',
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectingUser: false,
        confirming: false,
      }
    },
    methods: {
      showUser() {
      
      },
      async selectUser() {
        this.selectingUser = true
        
        this.$parent.$emit('user-selected', this.user, () => {
          this.selectingUser = false
          this.confirming    = false
          
          this.$parent.$emit('close-modal')
        })
      },
    },
    computed: {
      initials() {
        if(this.user.full_name) {
          return this.user.full_name.substring(0, 2)
        }
        
        return ''
      },
    },
  }
</script>
